import React from "react";
import {observer} from "mobx-react-lite";
import intl from "react-intl-universal";
import {useAppState, useRootStore, useUserState} from "@stores/AppStateContext";

import {getDaysLeft, getTotalDuration} from "../../../stores/client";
import {getDaysPassed} from "../../../utils/date";
import {Button} from "../../components/Button"
import {ProgressBarHorizontal} from "../../components/ProgressBarHorizontal"
import {RocketLaunch} from "../../components/icons/RocketLaunchIcon";
import {ProgressCircle} from "../../components/ProgressCircle";

import {MODALS} from "../../screens/modals/modal-names";

import "./UpgradePlanCard.css"

export const UpgradePlanCard = observer(() => {
    const appState = useAppState();
    const rootStore = useRootStore();
    const userState = useUserState();
    const clientRow = userState!.dsManager!.clientAR!.row!;
    const dayStart = clientRow.createdAt;
    const daysLeft = getDaysLeft(clientRow)
    const daysPast = getDaysPassed(dayStart)
    const totalDuration = getTotalDuration(clientRow);
    const percentage = (daysPast / totalDuration) * 100;
    const onClick = () => appState.setModal({name: MODALS.CHECKOUT, params: undefined});

    const isCollapsed = rootStore.isSidebarCollapsed;

    if (isCollapsed) {
        return (
            <div className="UpgradePlanCardCollapsed label-small"
                 onClick={onClick}
            >
                {intl.get('common.upgrade_plan.trial').d("Trial")}
                <ProgressCircle
                    className={""}
                    size={16}
                    circleThickness={3}
                    segments={[{
                        percentage,
                        status: 'upgrade',
                    }]}
                />
            </div>
        )
    }

    return (
        <div className="UpgradePlanCard">
            <div className="UpgradePlanCard__header_row body-medium">
                <span className={"UpgradePlanCard__header"}>{intl.get('common.subscription.free_trial').d('Free trial')}</span>
                <div className={"UpgradePlanCard__tail"}>
                    {intl.getHTML('upgrade.plan.card.days_left', {daysLeft}).d(`<b>${daysLeft}</b> days left`)}
                    <RocketLaunch size={16} className={"UpgradePlanCard__rocketIcon"}/>
                </div>
            </div>
            <ProgressBarHorizontal
                className={"UpgradePlanCard__ProgressBar"}
                maxWidth={256}
                type={"accent"}
                progress={percentage}/>
            <Button
                className={"UpgradePlanCard__button"}
                text={intl.get('common.upgrade_now').d("Upgrade now")}
                type={"accent"}
                style={'inline'}
                size={"sm"}
                onClick={onClick}
            />
        </div>
    )
});
